/*==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function (note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function (cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function (line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function (cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};


/**
 * Add new item to cart
 */

ShopifyAPI.addItemToCart = function (e, variant_id, quantity, callback) {
  if (!$('.pushmenu-left').hasClass('pushmenu-open'))
    $('.pushmenu-left').toggleClass('pushmenu-open');
   $('body section.pushpull').toggleClass("fn-drawer-open fn-drawer-open-right");
  $('body').toggleClass("js-drawer-openoverlay");
  $('html').css("overflow-y","hidden");
  
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function (cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdateAddItem(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);

};

/**
 * Update Item to Cart 
 */


// POST to cart/change.js returns the cart in JSON
ShopifyAPI.updateItem = function (id, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&id=' + id,
    dataType: 'json',
    success: function (cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdateItemQty(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/**
 * Remove from cart
 */

ShopifyAPI.removeItem = function (id, quantity, line, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&id=' + id,
    dataType: 'json',
    success: function (cart) {
      if ((typeof callback) === 'function') {
        // console.log("cb")
        callback(cart);
      }
      else {
        // console.log("calling")
        var curentQty = $("#itmqty" + id).val();
        var currentPrice = $("#itmPr" + id).text();
        var curSubtotal = $('#tmpSt').val();
        console.log(curentQty, currentPrice, curSubtotal);
        if (isNaN(curentQty) || isNaN(currentPrice) || isNaN(curSubtotal)) {
          window.location.reload();
        }
        var substractedValue = parseFloat(curSubtotal / 100) - (parseFloat(currentPrice) * parseInt(curentQty))
        ShopifyAPI.onCartUpdateRemoveItem(id);
        ShopifyAPI.updateSubTotal((substractedValue * 100));

      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onCartUpdateAddItem = function (data) {
  // add html to sidebar cart
  console.log(data);
  console.log(data.image);
  var curSubtotal = $('#tmpSt').val();
  var tempValue = (parseFloat(data.price));
  curSubtotal = parseFloat(curSubtotal) + tempValue;
  if (jQuery('#Floats' + data.variant_id).length == 0) {
    var addHtml2 = '<div id="Floats' + data.variant_id + '" class="ajaxcart__product" ><div class="ajaxcart__row" data-line="1"><div class="grid"><div class="grid__item two-fifths"><a href="' + data.url + '" title="' + data.title + '" class="ajaxcart__product-image"> <img src="' + data.image + '" alt="' + data.title + '"></a></div><div class="grid__item three-fifths"><p><a class="names_of_items" href="' + data.url + '" title="' + data.title + '" class="ajaxcart__product-name">' + data.title + '</a></p><div class="grid--full"><div class="grid__item one-whole text-center priceitemcart"><span><span class="money"> $ </span><span id="itmPr' + data.variant_id + '" class="money"> ' + (data.price / 100).toFixed(2) + ' </span> <span class="money"> USD </span></span></div><div class="grid__item one-whole text-center"><div class="ajaxcart__qty"><button type="button" onclick="ShopifyAPI.qtyIncDec(' + data.variant_id + ','+0+')" class="ajaxcart__qty-adjust ajaxcart__qty--minus icon-fallback-text" data-id="1163206761:c1d9dc4f0bcd6c0130829a883735b34f" data-qty="2" data-line="1"><span class="icon icon-minus" aria-hidden="true"></span> <span class="fallback-text" aria-hidden="true"><img src="https://cdn.shopify.com/s/files/1/1782/7341/t/147/assets/minus.png" alt="minus" width="50%"/></span></button><input type="text" id="itmqty' + data.variant_id + '" name="updates[]" class="ajaxcart__qty-num" value="' + data.quantity + '" min="0" data-id="1163206761:c1d9dc4f0bcd6c0130829a883735b34f" data-line="1" aria-label="quantity" pattern="[0-9]*"> <button type="button" onclick="ShopifyAPI.qtyIncDec(' + data.variant_id + ','+ 1 +')" class="ajaxcart__qty-adjust ajaxcart__qty--plus icon-fallback-text" data-id="1163206761:c1d9dc4f0bcd6c0130829a883735b34f" data-line="1" data-qty="4"> <span class="fallback-text" aria-hidden="true"><img src="https://cdn.shopify.com/s/files/1/1782/7341/t/147/assets/plus.png" alt="plus" width="50%"/></span> </button> </div> </div> <div class="grid__item one-whole text-center"> <a onClick="ShopifyAPI.removeItem(' + data.variant_id + ',0,1)" class="removeItm product_hover_effect" class="remitemcart">Remove</a></div> </div></div> </div> </div> </div>';


    var addHtml = '<div id="FloatsItms' + data.variant_id + '" class="tr"><div class="td" style="width: 25%;"><a href="' + data.url + '" title="' + data.title + '" class="cart_image"><img src="' + data.image + '" alt="' + data.title + '" /></a><br></div><div class="td"><b class="caps">' + data.title + '</b><br><span class="tc-price"> Qty </span><span id="spanqty' + data.variant_id + '" class="tc-price">' + data.quantity + '</span><br><span class="tc-price"> $ </span><span class="tc-price"> ' + (data.price / 100).toFixed(2) + ' </span> <span class="tc-price"> USD</span><br></div></div>';

    jQuery('.ajaxcart__inner').prepend(addHtml2);
    jQuery('#ct').prepend(addHtml);
    ShopifyAPI.updateSubTotal(curSubtotal);
  }
  else {
    ShopifyAPI.updateQty(data.variant_id, 1, data.quantity)
    ShopifyAPI.updateSubTotal(curSubtotal);
  }


};

ShopifyAPI.updateSubTotal = function (value) {
  console.log(value);
  $("#tmpSt").val(value);
  // $(".changeSubTot").text(parseFloat(value).toFixed(2));
  $(".changeSubTot").text(parseFloat(value/100).toFixed(2));
}

ShopifyAPI.qtyIncDec = function (vId, isInc) {
  var value = $("#itmqty" + vId).val();
  value = parseInt(value)

  var currentPrice = $("#itmPr" + vId).text();
  currentPrice = parseFloat(currentPrice)
  var curSubtotal = $('#tmpSt').val();
  curSubtotal = parseFloat(curSubtotal)

  if ( isNaN(currentPrice) || isNaN(curSubtotal)) {
    window.location.reload();
  }
  else {
    if (isInc) {
      value += 1;
      ShopifyAPI.updateQty(vId, 1, value);

      var substractedValue = parseFloat(curSubtotal) + (parseFloat(currentPrice) * 100)
      ShopifyAPI.updateSubTotal((substractedValue));
      ShopifyAPI.updateItem(vId, value)
    }
    else {
      value -= 1

      if (value == 0) {
        ShopifyAPI.removeItem(vId, 0, 1)
      }
      else {

        ShopifyAPI.updateQty(vId, 1, value);
        var substractedValue = parseFloat(curSubtotal) - (parseFloat(currentPrice) * 100)
        ShopifyAPI.updateSubTotal((substractedValue));
        ShopifyAPI.updateItem(vId, value)
      }
    }
  }
}


ShopifyAPI.updateQty = function (vId,  inc, value) {
  $("#itmqty" + vId).val(value);
  $("#spanqty" + vId).text(value);
}

ShopifyAPI.onCartUpdateRemoveItem = function (data) {
  console.log(data);
  //remove from sidebar and carthover
  if (jQuery('#Floats' + data).length > 0) {
    jQuery('#Floats' + data).remove();
    jQuery('#FloatsItms' + data).remove();
  }

  //substract from sub total
}

ShopifyAPI.onCartUpdateItemQty = function (data) {
  // add html to sidebar cart

}

ShopifyAPI.closeSideBar = function () {
  $('.pushmenu-left').toggleClass('pushmenu-open');
  $('body section.pushpull').toggleClass("fn-drawer-open fn-drawer-open-right");
   $('body').toggleClass("js-drawer-openoverlay");
  $('html').css("overflow-y","scroll");
}


$(document).ready(function() {
   $('input.ajaxcart__qty-num').focusout(function() {
        var val = $(this).val();
        if(isNaN(val)){
           $(this).val(1);
           var str =$(this).attr('id');
           var vId = str.substring(6);
           ShopifyAPI.updateItem(vId, 1)
           window.location.reload();
        }
        else{
           val = parseInt(val);
           var str =$(this).attr('id');
           var vId = str.substring(6)
           ShopifyAPI.updateItem(vId, val)
           window.location.reload();
        }
   });
  
 $('.blackoverlay').click(function(){
  	$('.pushmenu-left').toggleClass('pushmenu-open');
  $('body section.pushpull').toggleClass("fn-drawer-open fn-drawer-open-right");
   $('body').toggleClass("js-drawer-openoverlay");
  $('html').css("overflow-y","scroll");
  })

});